// Redux Articles module
// see https://github.com/erikras/ducks-modular-redux

const UPDATE_TABLE_STATE = 'pe/tables/UPDATE_TABLE_STATE';

const initialTableState = () => {
    return {
        page: 0,
        pageSize: 10
    }
};

const initialState = {
    usersTable : initialTableState(),
    studentsTable : initialTableState(),
    groupsTable : initialTableState(),
}

// Reducer
export default function reducer(state = initialState, action) {
    switch(action.type) {
        case UPDATE_TABLE_STATE:
            return {
                ...state,
                [action.id]: {
                    ...state[action.id],
                    ...action.state
                }
            };
        default:
            return state;
    }
};

export function updateTableState(id, state) { return { type: UPDATE_TABLE_STATE, id, state } }
